import { Modal } from 'bootstrap';

function setupConfirmationModals() {
  const modalToggles = document.querySelectorAll('a[data-confirmation]');
  if (modalToggles.length == 0) {
    return;
  }

  const confirmationModals = {};
  modalToggles.forEach((toggle) => {
    const associatedModal = document.getElementById(toggle.dataset.confirmation);
    if (!associatedModal) {
      console.error(`Could not find modal id associated to toggle #${toggle.dataset.confirmation}`);
      return;
    }

    // Skip if already set up to avoid duplicate event listeners
    if (toggle.dataset.confirmationSetup === 'true') {
      return;
    }

    confirmationModals[associatedModal.id] ??= new Modal(associatedModal);

    toggle.addEventListener('click', (e) => {
      e.preventDefault();

      confirmationModals[associatedModal.id].show(findRelatedTarget(toggle));
      const form = associatedModal.querySelector('form');
      if (form) {
        form.action = toggle.href;
      } else {
        const submitLink = associatedModal.querySelector('a[data-submit]');
        if (submitLink) {
          submitLink.href = toggle.href;
        }
      }
    });

    // Mark as set up to avoid duplicate listeners
    toggle.dataset.confirmationSetup = 'true';

    associatedModal.addEventListener('show.bs.modal', (e) => {
      const target = e.relatedTarget;
      if (target) {
        associatedModal.addEventListener(
          'hidden.bs.modal',
          () => {
            target?.focus();
          },
          { once: true },
        );
      }
    });
  });
}

function findRelatedTarget(toggle) {
  // Right now our problematic use case is having the bootstrap trigger inside a kebab so we check for that.
  // Else, we can simply focus on the trigger element as one would normally do.
  return toggle.closest('.dropdown')?.querySelector('.dropdown-toggle') || toggle;
}

// Initial setup on DOMContentLoaded
document.addEventListener('DOMContentLoaded', setupConfirmationModals);

// Re-setup after Turbo page loads (for full page refreshes)
document.addEventListener('turbo:load', setupConfirmationModals);

// Re-setup after Turbo renders (for partial updates)
document.addEventListener('turbo:render', setupConfirmationModals);
